export default function Canvas_Drawing() {
  return (
    <div>
      <h1>Canvas_Drawing Component</h1>
    </div>
  );
}
